import { LangEnum } from "../enums/lang.enum";
import i18next from "i18next";

export const ShortLangToEnum = (lang: string): 1 | 2 | 3 | 4 | 5 | 6 | 7 => {
    // Language detected from the browser may contain a region (e.g. "en-US") - compare only the base language
    const baseLang = (lang || "").split(/[-_]/)[0].toLowerCase();
    switch (baseLang) {
        case "pl":
            return LangEnum.Polish;
        case "en":
            return LangEnum.English;
        case "de":
            return LangEnum.German;
        case "sk":
            return LangEnum.Slovak;
        case "et":
            return LangEnum.Estonian;
        case "cs":
            return LangEnum.Czech;
        case "lt":
            return LangEnum.Lithuanian;
    }
    return LangEnum.Polish;
}

const mapLanguages: { [lang: string]: string } = {
    en: "en-US",
    de: "de-DE",
    sk: "sk-SK",
    et: "et-EE",
    cs: "cs-CZ",
    lt: "lt-LT",
};

export const ShortLangToMapLanguage = (lang: string): string | undefined =>
    mapLanguages[(lang || "").split(/[-_]/)[0].toLowerCase()];

const getLangEnumToCountryName = (lang: LangEnum, t: any): string => {
    switch (lang) {
        case LangEnum.Polish:
            return t("nav.countryPoland") as string;
        case LangEnum.English:
            return t("nav.countryEngland") as string;
        case LangEnum.German:
            return t("nav.countryGermany") as string;
        case LangEnum.Slovak:
            return t("nav.countrySlovakia") as string;
        case LangEnum.Estonian:
            return t("nav.countryEstonia") as string;
        case LangEnum.Czech:
            return t("nav.countryCzech") as string;
        case LangEnum.Lithuanian:
            return t("nav.countryLithuania") as string;
        default:
            return t("nav.countryPoland") as string;
    }
};

export const LangEnumToCountryName = (lang: LangEnum): string => {
    return getLangEnumToCountryName(lang, (key: string) => i18next.t(key, { ns: "admin" }));
}